import { logger } from 'ks-logger';
const console = logger('utils::localStorage');

/**
 * sets a value in localStorage using `key`
 * @param {*} key 
 * @param {*} value 
 */
export const setLocalStorage = (key, value) => {
  console.debug(`<setLocalStorage> key:${key}, value:${value}`);
  localStorage.setItem(key, value);
}

/**
 * gets value from localStorage
 * @param {*} key 
 */
export const getLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  return value;
}

/**
 * remove an item from localStorage
 * @param {*} key 
 */
export const removeLocalStorage = (key) => {
  console.debug(`<removeLocalStorage> key:${key}`);
  localStorage.removeItem(key);
}